/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { riskSignalsMcpServerCounts } from "../funcs/riskSignalsMcpServerCounts.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { RiskMcpServerCountsResult } from "../models/components/riskmcpservercountsresult.js";
import {
  GetRiskMcpServerCountsRequest,
  GetRiskMcpServerCountsSecurity,
} from "../models/operations/getriskmcpservercounts.js";
import { unwrapAsync } from "../types/fp.js";
export type RiskMcpServerCountsQueryData = RiskMcpServerCountsResult;

export function prefetchRiskMcpServerCounts(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetRiskMcpServerCountsRequest | undefined,
  security?: GetRiskMcpServerCountsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildRiskMcpServerCountsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildRiskMcpServerCountsQuery(
  client$: GramCore,
  request?: GetRiskMcpServerCountsRequest | undefined,
  security?: GetRiskMcpServerCountsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<RiskMcpServerCountsQueryData>;
} {
  return {
    queryKey: queryKeyRiskMcpServerCounts({
      from: request?.from,
      to: request?.to,
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function riskMcpServerCountsQueryFn(
      ctx,
    ): Promise<RiskMcpServerCountsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(riskSignalsMcpServerCounts(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyRiskMcpServerCounts(
  parameters: {
    from?: Date | undefined;
    to?: Date | undefined;
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "signals", "mcpServerCounts", parameters];
}
